import { createFileRoute } from "@tanstack/react-router";

import { ComplianceTaskForm } from "@/components/compliance/ComplianceTaskForm";
import { FeatureGate } from "@/components/shared/FeatureGate";
import { FEATURES } from "@/lib/features";

export const Route = createFileRoute("/_authenticated/compliance/new")({
  component: CreateComplianceTaskPage,
});

function CreateComplianceTaskPage() {
  return (
    <FeatureGate
      feature={FEATURES.COMPLIANCE_TASKS}
      featureName="Compliance tasks"
    >
      <ComplianceTaskForm mode="create" />
    </FeatureGate>
  );
}
